export const releaseNotesStyles = {
    '&  blockquote': {
        backgroundColor: '#DEEBFF',
        color: 'black',
        padding: '20px',
    },
};
